<template>
  <div class="dashboard-view">
    <div class="page-wrapper">
      <!--START: Menu-->
      <PageMenu
        :menu="menu"
        :highlightExactRoute="false"
        class="page-menu"
      ></PageMenu>
      <!--END: Menu-->

      <!--START: Settings View-->
      <div v-if="!showOptions.preLoader" class="page-content">
        <keep-alive
          ><router-view :reloadView="reloadView"></router-view
        ></keep-alive>
      </div>
      <!--END: Settings View-->

      <!--START: Pre Loader-->
      <div v-else class="pre-loader-wrapper">
        <PreLoader :show="true" v-for="index in 2" :key="index"></PreLoader>
      </div>
      <!--END: Pre Loader-->

      <!--START: Loader-->
      <LineLoader :show="showOptions.lineLoader"></LineLoader>
      <!--END: Loader-->

      <!--START: Notification Message-->
      <NotificationMessage
        :show="status.show"
        :status="status.status"
        :title="status.title"
      ></NotificationMessage>
      <!--END: Notification Message-->
    </div>
  </div>
</template>

<script>
// Import libraries
import _ from "lodash";

//Importing components
import PageMenu from "@/components/dashboard/PageMenu";
import NotificationMessage from "@/components/modals/NotificationMessage";
import LineLoader from "@/components/loaders/LineLoader";
import PreLoader from "@/components/loaders/PreLoader";

export default {
  name: "AiAssistant",
  data() {
    return {
      lodash: _,
      reloadView: false,
      showOptions: {
        lineLoader: false,
        preLoader: false,
      },
      menu: [
        {
          name: "AI activity",
          id: "tickets-menu",
          type: "category",
          menuItems: [
            {
              name: "Tickets",
              icon: "inbox",
              path: "/ai-assistant/tickets",
            },
          ],
        },
        {
          name: "AI behavior",
          type: "category",
          menuItems: [
            {
              name: "Personas",
              icon: "star",
              path: "/ai-assistant/personas",
            },
            {
              name: "Answer Rules",
              icon: "comment-alt",
              path: "/ai-assistant/answer-rules",
            },
            {
              name: "AI Signature",
              icon: "edit-alt",
              path: "/ai-assistant/signature",
            },
          ],
        },
        {
          name: "Settings",
          type: "category",
          menuItems: [
            {
              name: "Configuration",
              icon: "setting",
              path: "/ai-assistant/configuration",
            },
            {
              name: "Zendesk channels",
              icon: "channel",
              path: "/ai-assistant/zendesk-channels",
            },
            {
              name: "Agents",
              icon: "users-alt",
              path: "/ai-assistant/agents",
            },
          ],
        },
      ],
      status: {
        show: false,
        status: "success",
        title: "Widget saved",
      },
      saveInProgress: false,
    };
  },
  components: {
    PageMenu,
    NotificationMessage,
    LineLoader,
    PreLoader,
  },
  computed: {
    widget() {
      return this.$store.getters.widget;
    },
  },
  async created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

/deep/ .page-header {
  margin-bottom: 3rem;
}
/deep/ .line-loader {
  position: fixed;
  z-index: 101;
  bottom: 0;
  left: 0;
}
</style>
